import { Flex, Paragraph, Button } from '@vimeo/bokeh';
import { CircleExclamation } from '@vimeo/bokeh-icons';

import * as finalCopy from '../../copy/final';

interface Props {
  error: Error | null;
  onRetry: () => void;
}

export const ErrorState = ({ error, onRetry }: Props) => {
  return (
    <Flex
      w="100%"
      h="100%"
      gap="12px"
      alignItems="center"
      flexDirection="column"
      justifyContent="center"
    >
      <CircleExclamation boxSize="xl" color="text-primary" />
      <Paragraph p="12px" textAlign="center" color="text-primary">
        {`${finalCopy.errorOccurred}${error ? `: ${error}.` : '.'}`}
      </Paragraph>
      <Button variant="secondary" onClick={onRetry}>
        {finalCopy.refresh}
      </Button>
    </Flex>
  );
};
